<template>
   <div class="demo-import">
        <el-button :type="disabled?'defult':'primary'" :disabled="disabled" @click="dialogVisible = true"><slot name="button-name"></slot></el-button>
        <el-dialog
        title="导入"
        :visible.sync="dialogVisible"
        width="50%">
           <el-row>
               <el-upload
                    class='upload-demo'
                    ref="upload"
                    action=''
                    :on-remove='handleRemove'
                    :on-change='onchange'
                    :limit='1'
                    :on-exceed='handleExceed'
                    :on-success="successFunc"
                    :file-list='fileList'
                    :show-file-list='false'
                    :auto-upload='false'
                    :http-request = "addAttachment"
                    >
                    <el-button type='primary'>选择文件</el-button>
                </el-upload>
                <span v-if="maxSize">文件限制{{ maxSize }}MB</span>
           </el-row>
           <el-row>
               <el-table
                :data="fileList"
                stripe
                border>
                    <el-table-column prop="name" label="文件名称" width="180">
                    </el-table-column>
                    <el-table-column prop="size" label="大小" width="180">
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button @click="handleRemove(scope.row)" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
           </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitUpload">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import request from '@/utils/http';
export default {
    name: 'mImport',
    data() {
        return {
            fileList: [],
            dialogVisible: false
        };
    },
    props: {
        uploadUrl: String,
        disabled: Boolean,
        maxSize: {
            type: Number,
            default() {
                return 0; // 文件最大值MB，0表示不限制
            }
        }
    },
    computed: {
        myHeader() {
            return {
                'Content-Type': 'multipart/form-data'
            };
        }
    },
    methods: {
        submitUpload() {
            this.$refs.upload.submit();
        },
        handleExceed(files, fileList) {
            this.$message.warning(
                `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`
            );
        },
        handleRemove(row) {
            this.fileList.splice(row, 1);
        },
        onchange(file, fileList) {
            this.fileList = fileList;
            if (this.maxSize && file.size / 1024 / 1024 > this.maxSize) {
                this.$message.warning(`文件无法上传, 大小超过限制的${this.maxSize}MB`);
                this.fileList = fileList.filter(item => item.uid !== file.uid);
            }
        },
        successFunc() {
            this.dialogVisible = false;
            this.$emit('successFunc');
        },
        addAttachment(file) {
            const param = new FormData();
            param.append('file', file.file);
            return request({
                url: this.uploadUrl,
                method: 'post',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: param
            }).then(res => {
                if (res) {
                    this.$message.success('文件导入成功！');
                    this.dialogVisible = false;
                }
            });
        }
    },
    mounted() {
    },
    components: {}
};
</script>
<style lang='less'>
    .demo-import {
        display: inline-block;
        .upload-demo {
            margin-bottom: 10px;
            display: inline-block;
            margin-right: 10px;
        }
        .el-progress {
            display: inline-block;
            width: 200px;
        }
        h1 {
            font-size: 1.5em
        }
        .el-table th, .el-table td {
            text-align: center
        }
        .el-table {
            min-height: 200px !important;
            max-height: 200px !important;
        }
    }
</style>
